export default __webpack_public_path__ + "static/media/4_roadmap.b48183dc.png";